import script from "./DashboardViews.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardViews.vue?vue&type=script&setup=true&lang=js"

import "./DashboardViews.vue?vue&type=style&index=0&id=1ebbe728&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ebbe728"]])

export default __exports__